import Moment from "react-moment";
import * as React from "react";

export interface DateDisplayProperties {
    format?: string | null;
    date: Date;
}

export const DateDisplay: React.FC<DateDisplayProperties> = props => {
    return (
        <Moment
            date={props.date}
            format={props.format ?? "Do MMMM YYYY HH:mm"}
        />
    );
};
